import React from 'react'
import IUMRSHome from '../components/events/iumrs-icam25/IUMRSHome.jsx'
import useScrollBarPosition from '../hooks/useScrollBarPosition'
import styled from 'styled-components'
import IUMRSNavBar from '../components/events/iumrs-icam25/IUMRSNavbar.jsx'
import { ICAMNavroute } from '../utils/ICAMnavroute.js'
import BackToTop from '../components/BackToTop'
import NotificationDropdown from '../hooks/notificationsDropdown.jsx'
import useScreenSize from '../hooks/useScreenSize.js'

const IcamEvent = () => {

  const scrollPosition = useScrollBarPosition();
  const {width} = useScreenSize();

  return (
    <Wrapper>
      <IUMRSNavBar navroute={ICAMNavroute}/>
      <NotificationDropdown />
      <IUMRSHome/>
{ width < 850 ? (scrollPosition > 50) && <BackToTop /> : (scrollPosition > 95) && <BackToTop />}
    </Wrapper>
  )
}

const Wrapper = styled.div`
`
export default IcamEvent